import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useFeatures } from 'modules/core/hooks/useFeatures'

export const useMessageTemplatesFeatureAvailability = () => {
  const { has_dev_packaging_paywalls, has_ats_message_templates } = useFeatures([
    'dev_packaging_paywalls',
    'ats_message_templates',
  ])
  const { featureAvailability } = useFeatureAvailability(Features.ats_message_templates)

  return has_dev_packaging_paywalls ? featureAvailability.available : has_ats_message_templates
}
